<script>
  /**
 *
 *
 */

  /*                */
  let { formattedPrice } = $props();
</script>

{#if formattedPrice.originalPrice === undefined || formattedPrice.retailPrice === formattedPrice.originalPrice}
  <div class="oc-copy-75 oc-copy--bold">
    <span class="reco_aos_no_underline_price">{formattedPrice.retailPrice}</span>
  </div>
{:else}
  <div class="color-red oc-copy-75 oc-copy--bold">
    <span class="reco_aos_no_underline_price">{formattedPrice.retailPrice}</span>
  </div>
  <div class="oc-copy-75 color-grey">
    {#if formattedPrice.originalPricePrefix}
      {formattedPrice.originalPricePrefix}
    {/if}
    <span class="line-through">{formattedPrice.originalPrice}</span>
  </div>
{/if}

<style lang="scss">
  .reco_aos_no_underline_price {
    display: inline-block;
  }

  .line-through {
    text-decoration: line-through;
  }

  .color-red {
    color: var(--oc-semantic-color-brand);
  }

  .color-grey {
    color: var(--oc-semantic-color-text-default);
  }
</style>
